export default "__VITE_ASSET__eaa08f24__"